<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.78732 19.7124C2.87444 17.7995 1.7998 15.2051 1.7998 12.4999C1.7998 9.79472 2.87444 7.20031 4.78732 5.28744C6.70019 3.37457 9.2946 2.29993 11.9998 2.29993C14.705 2.29993 17.2994 3.37457 19.2123 5.28744C21.1252 7.20031 22.1998 9.79472 22.1998 12.4999C22.1998 15.2051 21.1252 17.7995 19.2123 19.7124C17.2994 21.6253 14.705 22.6999 11.9998 22.6999C9.2946 22.6999 6.70019 21.6253 4.78732 19.7124ZM16.6833 10.0465C16.9851 9.66919 16.924 9.11856 16.5466 8.81668C16.1693 8.5148 15.6186 8.57598 15.3167 8.95333L11.108 14.2143L8.59845 11.8616C8.2459 11.5311 7.69217 11.5489 7.36166 11.9015C7.03114 12.254 7.04901 12.8078 7.40155 13.1383L10.6016 16.1383C10.7795 16.3052 11.0191 16.3901 11.2625 16.3727C11.5058 16.3553 11.7309 16.2371 11.8833 16.0465L16.6833 10.0465Z"
      fill="currentColor"
    />
  </svg>
</template>
